export default "__VITE_ASSET__10c6fb09__"